/**
 * Get current slide index depending on the current drag offset
 * @returns Index of the current slide
 */
export const getCurrentSlideIndex = ({
	x,
	widths,
	reversedWidths,
	totalWidths,
	items,
}) => {
	let passedWidth = 0;
	let currentSlideRealIndex = 0;

	if (x > 0) {
		// Add slides widths until reaching the current X offset to get the slide index
		widths.forEach((width, i) => {
			if (passedWidth < x % totalWidths) {
				passedWidth += width;
				// Current slide index will depend if we've reached more or less of this last slide center
				if (passedWidth - width / 2 <= x % totalWidths) {
					currentSlideRealIndex = i + 1;
				} else {
					currentSlideRealIndex = i;
				}
			}
		});
	} else {
		// If x is below 0, it means we are in loop mode, and the position of the slides are reversed
		// (slide `-1` is slide `items.length`; slide `-2` is slide `items.length - 1`; etc...)
		reversedWidths.forEach((width, i) => {
			// Add slides widths until reaching the current X offset to get the slide index
			if (passedWidth < Math.abs(x) % totalWidths) {
				passedWidth += width;
				// Current slide index will depend if we've reached more or less of this last slide center
				if (passedWidth - width / 2 <= Math.abs(x) % totalWidths) {
					currentSlideRealIndex = items.length - i - 1;
				} else {
					currentSlideRealIndex = items.length - i;
				}
			}
		});
	}

	return currentSlideRealIndex;
};
